import { useDraggable } from '@/hooks/useDraggable';
import { Coordinate } from '@/model/GraphicModel';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import styles from './draggableWindow.module.scss';

type Props = {
	footer?: React.ReactNode;
	header: React.ReactNode;
	id: string;
	initialCoordinates: Coordinate;
	parentContainerId: string;
	parentCoordinates: Coordinate;
	onClose: () => void;
	onDragEnd?: (coordinate: Coordinate) => void;
	children?: React.ReactNode;
};

const DraggableWindow: FC<Props> = ({ children, footer, header, id, initialCoordinates, parentContainerId, parentCoordinates, onClose, onDragEnd }) => {
	const targetContainerId: string = `draggableWindow_${id}`;
	const targetDragContainerId: string = `draggableWindowContent_${id}`;

	useDraggable({
		parentContainerId,
		targetContainerId,
		targetDragContainerId,
		initialCoordinates,
		parentCoordinates,
		onDragEnd: (coordinate: Coordinate) => onDragEnd?.(coordinate),
	});

	return createPortal(
		<div id={targetContainerId} className={styles.mainContainer}>
			<div id={`draggableWindowContainer_${id}`} className={styles.floatingWindowInnerContainer}>
				<div id={`draggableWindowHeader_${id}`} className={styles.floatingWindowHeader}>
					{header}
					<div>
						<Button onClick={onClose} className={styles.floatingWindowBannerButton} type='text' size='small' icon={<CloseOutlined />} />
					</div>
				</div>
				<div id={targetDragContainerId} className={styles.floatingWindowContent}>
					{children}
				</div>
				{footer && (
					<div id={`draggableWindowFooter_${id}`} className={styles.floatingWindowFooter}>
						{footer}
					</div>
				)}
			</div>
		</div>,
		document.getElementById(parentContainerId)
	);
};

export { DraggableWindow };
